import { Box } from '@tempmee/react';
import { useNavigate } from 'react-router';
import { AuthBackLink } from '~/components/AuthRedesign/shared';
import { routes } from '~/routes';
import { useRequireSignUpStep } from '../shared/useRequireSignUpStep';
import { InfoBanner } from './sections';
import { WorkerTypeForm } from './WorkerTypeForm';

const BANNER_GAP = 16;

export const WorkerTypePage = () => {
  useRequireSignUpStep();
  const navigate = useNavigate();

  return (
    <Box>
      <Box style={{ paddingTop: BANNER_GAP, paddingRight: 16, paddingLeft: 16 }}>
        <InfoBanner />
      </Box>
      <Box style={{ position: 'relative', padding: '40px 0 80px' }}>
        <Box style={{ position: 'absolute', left: 28, top: 40 }}>
          <AuthBackLink to={routes.signUpRedesign.officeSetup} />
        </Box>
        <WorkerTypeForm onSuccess={() => navigate('/dashboard')} />
      </Box>
    </Box>
  );
};
